import React, { useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { useDocumentTitle } from '@mantine/hooks';
import { HeaderMenu } from "../../components/HeaderMenu/HeaderMenu";
import { Modal, Container, Card, Group, Text, Button, Accordion, Table, Image, Radio, Checkbox, LoadingOverlay, Loader, Stack, Code, CopyButton, Tooltip, ActionIcon, TextInput } from '@mantine/core';
import { IconBrandFacebook, IconBrandGoogle, IconBrandWindows, IconBrandTiktok, IconBrandLinkedin, IconBrandOpenai, IconCopy, IconCheck } from '@tabler/icons-react';
import classes from '../DashBoard/DashBoard.module.css';

import { modals } from '@mantine/modals';
import { useEffect } from 'react';
import { VisiLoader, HelpTip } from "../../components/GeneralComponent/GeneralComponent";
import { visiUserToken } from '../../GeneralFunction';
import CampaignApi from "../../api/CampaignApi";
import FacebookLogin from '@greatsumini/react-facebook-login';
import { useGoogleLogin } from '@react-oauth/google';
import { Step1 } from '../../components/CreateCampaign/Step1';
import { Step4 } from '../../components/CreateCampaign/Step4';
import { Step5 } from '../../components/CreateCampaign/Step5';

export function CreateCampaign() {

  let visi_token = visiUserToken() ? visiUserToken() : '';

	const navigate = useNavigate();
	useDocumentTitle("Visiopt - Create Campaign");
	const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');

  let { campaign_id } = useParams();
  campaign_id = campaign_id === 'new' ? '' : campaign_id;


	const handleHeaderMenuComponentChange = (Value:any) => {
	  setSelectedMemberWebsite(Value);
	};
	const [campaignLPPageValue, setCampaignLPPage] = useState('');

	const [isMessageModelOpen, setIsMessageModelOpen] = useState(false);
	const [isModelMessage, setIsModelMessage] = useState('');
  const [conversionApiType, setConversionApiType] = useState('');

	// State to manage the checkbox
	const [isClassicChecked, setIsClassicChecked] = useState(true);
  const [isFacebookChecked, setIsFacebookChecked] = useState(false);
  const [isGoogleChecked, setIsGoogleChecked] = useState(false);
  const [isMicrosoftChecked, setIsMicrosoftChecked] = useState(false);
  const [isTiktokChecked, setIsTiktokChecked] = useState(false);
  const [isTaboolaChecked, setIsTaboolaChecked] = useState(false);
  const [isOutbrainChecked, setIsOutbrainChecked] = useState(false);
  const [isApplovinChecked, setIsApplovinChecked] = useState(false);
  const [isChatgptChecked, setIsChatgptChecked] = useState(false);
  const [isLinkedinChecked, setIsLinkedinChecked] = useState(false);

  const [facebookLoginButton, setFacebookLoginButton] = useState(false);
  const [facebookLogoutButton, setFacebookLogoutButton] = useState(false);
  const [facebookAppId, setFacebookAppId] = useState('');
  const [facebookApiPath, setFacebookApiPath] = useState('');
  const [facebookElements, setFacebookElements] = useState([]);
  const [taboolaClientId, setTaboolaClientId] = useState('');
  const [googleLoginButton, setGoogleLoginButton] = useState(false);
  const [googleLogoutButton, setGoogleLogoutButton] = useState(false);
  const [googleElements, setGoogleElements] = useState([]);
  const [tiktokLoginButton, setTiktokLoginButton] = useState(false);
  const [tiktokLogoutButton, setTiktokLogoutButton] = useState(false);
  const [outbrainLoginButton, setOutbrainLoginButton] = useState(false);
  const [outbrainLogoutButton, setOutbrainLogoutButton] = useState(false);
  const [outbrainElements, setOutbrainElements] = useState([]);
  const [taboolaLoginButton, setTaboolaLoginButton] = useState(false);
  const [taboolaLogoutButton, setTaboolaLogoutButton] = useState(false);
  const [taboolaElements, setTaboolaElements] = useState([]);
  const [microsoftLoginButton, setMicrosoftLoginButton] = useState(false);
  const [microsoftLogoutButton, setMicrosoftLogoutButton] = useState(false);
  const [microsoftElements, setMicrosoftElements] = useState([]);
  const [applovinLoginButton, setApplovinLoginButton] = useState(false);
  const [applovinLogoutButton, setApplovinLogoutButton] = useState(false);
  const [chatgptLoginButton, setChatgptLoginButton] = useState(false);
  const [chatgptLogoutButton, setChatgptLogoutButton] = useState(false);
  const [chatgptModalOpen, setChatgptModalOpen] = useState(false);
  const [chatgptToken, setChatgptToken] = useState('');
  const [chatgptSaving, setChatgptSaving] = useState(false);
  const [chatgptError, setChatgptError] = useState('');
  const [linkedinLoginButton, setLinkedinLoginButton] = useState(true);
  const [linkedinLogoutButton, setLinkedinLogoutButton] = useState(false);
  const [linkedinElements, setLinkedinElements] = useState([]);

  const [fbloginResponse, setfbloginResponse] = useState('');
  const [fbResponse, setfbResponse] = useState('');
  const [fbUserId, setfbUserId] = useState('');
  const [fbUserAccesstoken, setfbUserAccesstoken] = useState(0);
  const [fbAccountsDetails, setfbAccountsDetails] = useState([]);
  const [selectedFbAccounts, setSelectedFbAccounts] = useState([]);
  const [fbNextPageUrl, setFbNextPageUrl] = useState<string | null>(null);
  const [fbPaginationLoading, setFbPaginationLoading] = useState(false);
  const [fbAccessToken, setFbAccessToken] = useState('');
  const [fbAdAccountPages, setFbAdAccountPages] = useState<any[][]>([]);
  const [fbCurrentPageIndex, setFbCurrentPageIndex] = useState(0);

  const [glUserRefreshtoken, setglUserRefreshtoken] = useState(0);
  const [glAccountsDetails, setglAccountsDetails] = useState([]);
  const [selectedGlAccounts, setSelectedGlAccounts] = useState('');

  const [obUsertoken, setobUsertoken] = useState(0);
  const [obAccountsDetails, setobAccountsDetails] = useState([]);
  const [selectedObAccounts, setSelectedObAccounts] = useState('');
  const [selectedObConvAccounts, setSelectedObConvAccounts] = useState('');

  const [googleLoader, setGoogleLoader] = useState(false);
  const [fbAllConversionSend, setfbAllConversionSend] = useState(0);

  const [tbUserRefreshtoken, settbUserRefreshtoken] = useState(0);
  const [tbAccountsDetails, settbAccountsDetails] = useState([]);
  const [selectedTbAccounts, setSelectedTbAccounts] = useState('');

  const [msUserRefreshtoken, setmsUserRefreshtoken] = useState(0);
  const [msAuthorizationData, setmsAuthorizationData] = useState([]);
  const [selectedMsAccounts, setSelectedMsAccounts] = useState('');
  const [selectedMsConvAdsAccounts, setSelectedMsConvAdsAccounts] = useState('');

  const [tkUserAccesstoken, settkUserAccesstoken] = useState(0);
  const [tkAccountsDetails, settkAccountsDetails] = useState([]);
  const [selectedTkAccounts, setSelectedTkAccounts] = useState('');
  const [selectedTkConvAdsAccounts, setSelectedTkConvAdsAccounts] = useState('');
  const [tiktokElements, setTiktokElements] = useState([]);
  const [tiktokAppId, setTiktokAppId] = useState('');

  const [selectedLnAccounts, setSelectedLnAccounts] = useState('');
  const [lnAccesstoken, setLnAccesstoken] = useState('');
  const handleFacebookChecked = () => {
    setCampaignLoader(true);
    CampaignApi.getcampaigntypeaduserdata({
      campaign_type: 'facebook',
      campaign_id: campaignId || campaign_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data){
        if(data.data){
          if(data.data.show_fb_ad_account_login_logout_button){
            if(data.data.show_fb_ad_account_login_logout_button === 'login'){
              setFacebookLoginButton(true);
              setFacebookLogoutButton(false);
            }else if(data.data.show_fb_ad_account_login_logout_button === 'logout'){
              setFacebookLogoutButton(true);
              setFacebookLoginButton(false);
              if(data.data.fb_ad_accounts){
                const fbad_accounts = Array.isArray(data.data.fb_ad_accounts)? data.data.fb_ad_accounts: data.data.fb_ad_accounts === "No Data Found."
                  ? [] : [data.data.fb_ad_accounts];
                setFacebookElements(fbad_accounts);
                const pages: any[][] = [];
                for (let i = 0; i < fbad_accounts.length; i += 100) {
                  pages.push(fbad_accounts.slice(i, i + 100));
                }
                setFbAdAccountPages(pages.length > 0 ? pages : [[]]);
                setFbCurrentPageIndex(0);
              }
              if(data.data.fb_paging_next) setFbNextPageUrl(data.data.fb_paging_next);
            }
          }
          if(data.data.facebook_app_id){
            setFacebookAppId(data.data.facebook_app_id);
          }
          if(data.data.facebook_api_path){
            setFacebookApiPath(data.data.facebook_api_path);
          }
          setCampaignLoader(false);
        }
      }
    })
    .catch(error => {
      setCampaignLoader(false);
      console.error("API Error:", error);
    });
  };

  const handleGoogleChecked = () => {
    setGoogleLoader(true);
    CampaignApi.getcampaigntypeaduserdata({
      campaign_type: 'google',
      campaign_id: campaignId || campaign_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data){
        if(data.data){
          if(data.data.show_gl_ad_account_login_logout_button){
            if(data.data.show_gl_ad_account_login_logout_button === 'login'){
              setGoogleLoginButton(true);
              setGoogleLogoutButton(false);
            }else if(data.data.show_gl_ad_account_login_logout_button === 'logout'){
              setGoogleLogoutButton(true);
              setGoogleLoginButton(false);
              if(data.data.gl_adaccount_details){
                const glad_accounts = Array.isArray(data.data.gl_adaccount_details)? data.data.gl_adaccount_details: data.data.gl_adaccount_details === "No Data Found."
                  ? [] : [data.data.gl_adaccount_details];
                setGoogleElements(glad_accounts);
              }
            }
          }          
          setGoogleLoader(false);
        }
      }
    })
    .catch(error => {
      setGoogleLoader(false);
      console.error("API Error:", error);
    });  
  };

  const handleMicrosoftChecked = () => {
    setCampaignLoader(true);
    CampaignApi.getcampaigntypeaduserdata({
      campaign_type: 'microsoft',
      campaign_id: campaignId || campaign_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data){
        if(data.data){
          if(data.data.show_ms_ad_account_login_logout_button){
            if(data.data.show_ms_ad_account_login_logout_button === 'login'){
              setMicrosoftLoginButton(true);
              setMicrosoftLogoutButton(false);
            }else if(data.data.show_ms_ad_account_login_logout_button === 'logout'){
              setMicrosoftLogoutButton(true);
              setMicrosoftLoginButton(false);
              if(data.data.ms_ad_accounts){
                const msad_accounts = Array.isArray(data.data.ms_ad_accounts)? data.data.ms_ad_accounts: [];
                setMicrosoftElements(msad_accounts);
              }
            }
          }
          setCampaignLoader(false);
        }
      }
    })
    .catch(error => {
      setCampaignLoader(false);
      console.error("API Error:", error);
    });
  };

  const handleTiktokChecked = () => {
    setCampaignLoader(true);
    CampaignApi.getcampaigntypeaduserdata({
      campaign_type: 'tiktok',
      campaign_id: campaignId || campaign_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data){
        if(data.data){
          if(data.data.show_tk_ad_account_login_logout_button){
            if(data.data.show_tk_ad_account_login_logout_button === 'login'){
              setTiktokLoginButton(true);
              setTiktokLogoutButton(false);
            }else if(data.data.show_tk_ad_account_login_logout_button === 'logout'){
              setTiktokLogoutButton(true);
              setTiktokLoginButton(false);
              if(data.data.tk_ad_accounts){
                const tkad_accounts = Array.isArray(data.data.tk_ad_accounts)? data.data.tk_ad_accounts: data.data.tk_ad_accounts === "No Data Found."
                  ? [] : [data.data.tk_ad_accounts];
                setTiktokElements(tkad_accounts);
              }
            }
          }
          if(data.data.tiktok_app_id){
            setTiktokAppId(data.data.tiktok_app_id);
          }          
          setCampaignLoader(false);
        }
      }
    })
    .catch(error => {
      setCampaignLoader(false);
      console.error("API Error:", error);
    });
  };

  // Handler for checkbox change
  const handleSocialMediaCheckboxChange = (event,value) => {
  	if(value === 'Classic'){
  		setIsClassicChecked(event.target.checked);
  	} else if(value === 'Facebook'){
  		setIsFacebookChecked(event.target.checked);
  		if(event.target.checked === true){
  			setIsModelMessage("In order for this campaign to track Facebook Data be sure to add the following parameter either direct to your url or in Facebook's URL Parameters.\nvisi_source=facebook&ad_id={{ad.id}}");
      	setIsMessageModelOpen(true);
        handleFacebookChecked();
  		}
  	} else if(value === 'Google'){
  		setIsGoogleChecked(event.target.checked);
  		if(event.target.checked === true){
  			setIsModelMessage("In order for this campaign to track Google Data, be sure to add the following parameter either direct to your URL or in Google's URL Tracking Template.\n\n{lpurl}?visi_source=google&creative={creative}&visiclk={gclid}&visigl={wbraid}&visibr={gbraid}\n\n**Why the extra parameters?** Some browsers strip Google's standard click IDs (gclid, wbraid, gbraid) before they reach your landing page, which breaks attribution — especially for Demand Gen campaigns. The visiclk, visigl, and visibr parameters act as backups so the click ID is preserved and passed through the Conversion API.\n\nIf you also want to track keywords, use the following Tracking Template:\n\n{lpurl}?visi_source=google&creative={creative}&keyword={keyword}&visiclk={gclid}&visigl={wbraid}&visibr={gbraid}\n\nThe above will automatically pass campaign, ad group, ads, cost, and click ID information. To add additional parameters such as keyword, etc., visit the URL builder in Settings page.");
      	setIsMessageModelOpen(true);
        handleGoogleChecked();
  		}
  	} else if(value === 'Microsoft'){
  		setIsMicrosoftChecked(event.target.checked);
  		if(event.target.checked === true){
  			setIsModelMessage("In order for this campaign to track Microsoft Data be sure to add the following parameter either direct to your url or in Microsoft's URL Tracking Template.\n{lpurl}?visi_source=microsoft&AdGroupID={AdGroupID}");
      	setIsMessageModelOpen(true);
        handleMicrosoftChecked();
  		}
  	} else if(value === 'Tiktok'){
  		setIsTiktokChecked(event.target.checked);
  		if(event.target.checked === true){
  			setIsModelMessage("In order for this campaign to track Tiktok Data be sure to add the following parameter either direct to your url or in Tiktok's URL Tracking Template.\n{lpurl}?visi_source=tiktok&adid=__ADID__");
      	setIsMessageModelOpen(true);
        handleTiktokChecked();
  		}
  	} else if(value === 'Taboola'){
  		setIsTaboolaChecked(event.target.checked);
  		if(event.target.checked === true){
  			setIsModelMessage("In order for this campaign to track Taboola Data be sure to add the following parameter either direct to your url or in Taboola's URL Tracking Template.\n{lpurl}?visi_source=taboola&campaign_id={campaign_id}\n\nIf you also want to track country and platform and site use the follow Tracking Template:\n{lpurl}?visi_source=taboola&campaign_id={campaign_id}&country={country}&platform={platform}&site={site}");
      	setIsMessageModelOpen(true);
        getTaboolaAdUserData();
  		}
  	} else if(value === 'Outbrain'){
  		setIsOutbrainChecked(event.target.checked);
  		if(event.target.checked === true){
  			setIsModelMessage("In order for this campaign to track Outbrain Data be sure to add the following parameter either direct to your url or in Outbrain's URL Tracking Template.\n{lpurl}?visi_source=outbrain&campaign_id={campaign_id}");
      	setIsMessageModelOpen(true);
        getOutbrainAdUserData();
    	}
  	} else if(value === 'Applovin'){
      setIsApplovinChecked(event.target.checked);
      if(event.target.checked === true){
        setIsModelMessage("In order for this campaign to track Applovin Data be sure to add the following parameter either direct to your url or in Applovin's URL Tracking Template.\n{lpurl}?visi_source=applovin&ad_id={AD_ID}");
        setIsMessageModelOpen(true);
        getApplovinAdUserData();
      }
    } else if(value === 'Chatgpt'){
      setIsChatgptChecked(event.target.checked);
      if(event.target.checked === true){
        setIsModelMessage("In order for this campaign to track Paid ChatGPT Data be sure to add the following parameter to all of your ChatGPT paid ad destination URLs.\n{lpurl}?visi_ai=chatgpt_paid\n\nThis parameter is required for attribution and reporting.");
        setIsMessageModelOpen(true);
        getChatgptAdUserData();
      }
    } else if(value === 'Linkedin'){
      setIsLinkedinChecked(event.target.checked);
      if(event.target.checked === true){
        setIsModelMessage("In order for this campaign to track LinkedIn Data be sure to add the following parameter either direct to your url or in LinkedIn's URL Tracking Template.\n{lpurl}?visi_source=linkedin&ad_id={{CREATIVE_ID}}");
        setIsMessageModelOpen(true);
        getLinkedInAdUserData();
      }
    }
  };
  const handleCloseModal = () => {
    setIsMessageModelOpen(false);
  };

  useEffect(() => {
    if(isFacebookChecked){
      handleFacebookChecked();
    }
  },[isFacebookChecked]);

  useEffect(() => {
    if(isGoogleChecked){
      handleGoogleChecked();
    }
  },[isGoogleChecked]);

  useEffect(() => {
    if(isMicrosoftChecked){
      handleMicrosoftChecked();
    }
  },[isMicrosoftChecked]);

  useEffect(() => {
    if(isTiktokChecked){
      handleTiktokChecked();
    }
  },[isTiktokChecked]);

  useEffect(() => {
    if(isTaboolaChecked){
      getTaboolaAdUserData();
    }
  },[isTaboolaChecked]);

  useEffect(() => {
    if(isOutbrainChecked){
      getOutbrainAdUserData();
    }
  },[isOutbrainChecked]);

  useEffect(() => {
    if(isApplovinChecked){
      getApplovinAdUserData();
    }
  },[isApplovinChecked]);

  useEffect(() => {
    if(isChatgptChecked){
      getChatgptAdUserData();
    }
  },[isChatgptChecked]);

  useEffect(() => {
    if(isLinkedinChecked){
      getLinkedInAdUserData();
    }
  },[isLinkedinChecked]);

  const handleCheckboxChange = (adAccountId) => {
    setSelectedFbAccounts((prevSelected) => {
      const selectedArray = Array.isArray(prevSelected) ? prevSelected : [];
      if (selectedArray.includes(adAccountId)) {
        return selectedArray.filter((id) => id !== adAccountId);
      } else {
        return [...selectedArray, adAccountId];
      }
    });
  };

  const formattedSelectedFbAccounts = Array.isArray(selectedFbAccounts)
  ? selectedFbAccounts
  : [selectedFbAccounts];

  const currentFbPageAccounts = fbAdAccountPages[fbCurrentPageIndex] || [];
  const hasPrevFbPage = fbCurrentPageIndex > 0;
  const hasNextFbPage = fbCurrentPageIndex + 1 < fbAdAccountPages.length || fbNextPageUrl !== null;

  const handleFbNextPage = () => {
    if (fbCurrentPageIndex + 1 < fbAdAccountPages.length) {
      setFbCurrentPageIndex(prev => prev + 1);
    } else if (fbNextPageUrl) {
      // Extract access_token from the next URL if not already set (edit mode)
      let token = fbAccessToken;
      if (!token) {
        try {
          const urlObj = new URL(fbNextPageUrl);
          token = urlObj.searchParams.get('access_token') || '';
        } catch(e) { token = ''; }
      }
      fetchAdAccounts(token, fbUserId || '', fbNextPageUrl);
    }
  };

  const handleFbPrevPage = () => {
    setFbCurrentPageIndex(prev => prev - 1);
  };

	const facebookRows = currentFbPageAccounts.length > 0 ? (
  currentFbPageAccounts.map((element) => (
    <tr key={element.ad_account_id}>
      <td>{element.ad_account_id}</td>
      <td>{element.account_name}</td>
      <td>{element.currency}</td>
      <td>
        <Checkbox
          checked={selectedFbAccounts.includes(element.ad_account_id)}
          onChange={() => handleCheckboxChange(element.ad_account_id)}
        />
      </td>
    </tr>
  ))
  ) : (
    <tr>
      <td colSpan={4} style={{ textAlign: "center" }}><Text>No data found</Text></td>
    </tr>
  );

  const handleGlRadioChange = (value) => {
    setSelectedGlAccounts(value);
  };

	const googleRows = googleElements.length > 0 ? (
  googleElements.map((element) => (
    <tr key={element.subcustomer_id}>
      <td>{element.customer_id}</td>
      <td>{element.subcustomer_id}</td>
      <td>{element.subcustomer_name}</td>
      <td>{element.currency}</td>
      <td>
        <Radio
          name="googleIntegrationAccount"
          value={`${element.subcustomer_id}_${element.customer_id}`}
          checked={selectedGlAccounts === `${element.subcustomer_id}_${element.customer_id}`}
          onChange={(e) => handleGlRadioChange(`${element.subcustomer_id}_${element.customer_id}`)}
        />
      </td>
    </tr>
  ))
  ) : (
    <tr>
      <td colSpan={5} style={{ textAlign: "center" }}><Text>No data found</Text></td>
    </tr>
  );

  const handleMsRadioChange = (value) => {
    setSelectedMsAccounts(value);
  };

	const microsoftRows = microsoftElements.length > 0 ? (
  microsoftElements.map((element) => (
    <tr key={element.account_name}>
      <td>{element.ads_account_id}</td>
      <td>{element.account_name}</td>
      <td>{element.currency}</td>
      <td>
        <Radio
          name="microsoftIntegrationAccount"
          value={`${element.select_ad_account}`}
          checked={selectedMsAccounts === `${element.select_ad_account}`}
          onChange={(e) => handleMsRadioChange(`${element.select_ad_account}`)}
        />
      </td>
    </tr>
  ))
  ) : (
    <tr>
      <td colSpan={5} style={{ textAlign: "center" }}><Text>No data found</Text></td>
    </tr>
  );

  const handleTkRadioChange = (value) => {
    setSelectedTkAccounts(value);
  };

	const tiktokRows = tiktokElements.length > 0 ? (
  tiktokElements.map((element) => (
    <tr key={element.account_name}>
      <td>{element.ads_account_id}</td>
      <td>{element.account_name}</td>
      <td>{element.currency}</td>
      <td>
        <Radio
          name="tiktokIntegrationAccount"
          value={`${element.ads_account_id}`}
          checked={selectedTkAccounts === `${element.ads_account_id}`}
          onChange={(e) => handleTkRadioChange(`${element.ads_account_id}`)}
        />
      </td>
    </tr>
  ))
  ) : (
    <tr>
      <td colSpan={5} style={{ textAlign: "center" }}><Text>No data found</Text></td>
    </tr>
  );

  const handleTbRadioChange = (value) => {
    setSelectedTbAccounts(value);
  };

	const taboolaRows = taboolaElements.length > 0 ? (
    taboolaElements.map((element) => (
    <tr key={element.account_name}>
      <td>{element.ad_account_id}</td>
      <td>{element.account_name}</td>
      <td>{element.currency}</td>
      <td>
        <Radio
          name="taboolaIntegrationAccount"
          value={`${element.ads_account_id}_${element.account_id}`}
          checked={selectedTbAccounts === `${element.ads_account_id}_${element.account_id}`}
          onChange={(e) => handleTbRadioChange(`${element.ads_account_id}_${element.account_id}`)}
        />
      </td>
    </tr>
    ))
  ) : (
    <tr>
      <td colSpan={4} style={{ textAlign: "center" }}><Text>No data found</Text></td>
    </tr>
  );

  const handleObRadioChange = (value) => {
    setSelectedObAccounts(value);
  };

  const handleLnRadioChange = (value) => {
    setSelectedLnAccounts(value);
  };

	const outbrainRows = outbrainElements.length > 0 ? (
    outbrainElements.map((element) => (
    <tr key={element.account_name}>
      <td>{element.ads_account_id}</td>
      <td>{element.account_name}</td>
      <td>{element.currency}</td>
      <td>
        <Radio
          name="outbrainIntegrationAccount"
          value={`${element.ads_account_id}`}
          checked={selectedObAccounts === `${element.ads_account_id}`}
          onChange={(e) => handleObRadioChange(`${element.ads_account_id}`)}
        />
      </td>
    </tr>
    ))
  ) : (
    <tr>
      <td colSpan={4} style={{ textAlign: "center" }}><Text>No data found</Text></td>
    </tr>
  );

  const linkedinRows = linkedinElements.length > 0 ? (
    linkedinElements.map((element) => (
    <tr key={element.account_name}>
      <td>{element.ad_account_id}</td>
      <td>{element.account_name}</td>
      <td>{element.currency}</td>
      <td>
        <Radio
          name="outbrainIntegrationAccount"
          value={`${element.ad_account_id}`}
          checked={selectedLnAccounts === `${element.ad_account_id}`}
          onChange={(e) => handleLnRadioChange(`${element.ad_account_id}`)}
        />
      </td>
    </tr>
    ))
  ) : (
    <tr>
      <td colSpan={4} style={{ textAlign: "center" }}><Text>No data found</Text></td>
    </tr>
  );

  const [convAttributionModel, setConvAttributionModel] = useState('1');
  const handleConvAttributionModelChange = (value:any) => {
    setConvAttributionModel(value);
  }

	const [SelectedFunnelValue, setSelectedFunnelValue] = useState(null);
	const [campaignLoader, setCampaignLoader] = useState(false);
  const [step1FieldDisabled, setStep1FieldDisabled] = useState(false);
	const [step3Disabled, setStep3Disabled] = useState(true);
	const [step4Disabled, setStep4Disabled] = useState(true);
	const [step5Disabled, setStep5Disabled] = useState(true);
  const [step5Show, setStep5Show] = useState('0');
	const [campaignName, setCampaignName] = useState('');
	const [stepValue, setStepValue] = useState('step-1');
	const [campaignId, setCampaignId] = useState('');

  const [glConvCustomerId, setGlConvCustomerId] = useState('');
  const [glConvSubCustomerId, setGlConvSubCustomerId] = useState('');
  const [tbAdAccountId, setTbAdAccountId] = useState('');

  useEffect(() => {
    if(campaign_id !== "" && campaign_id !== undefined && campaign_id !== 'new'){
      handleCampaignDetail();
    }
  }, [campaign_id]);

  const handleCampaignDetail = () => {
    setCampaignLoader(true);
    CampaignApi.getcampaigndetail({
      c_id:campaign_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          setCampaignLoader(false);
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        setStep1FieldDisabled(true);
        setStep3Disabled(false);
        setStep4Disabled(false);
        setStep5Disabled(false);
        setSelectedFunnelValue(data.data.campaign_detail.funnel_id);
        setCampaignName(data.data.campaign_detail.campaign_name);
        setCampaignLPPage(data.data.campaign_detail.campaign_page);
        setIsClassicChecked(data.data.campaign_detail.campaign_type_classic);
        setIsFacebookChecked(data.data.campaign_detail.campaign_type_facebook);
        setIsGoogleChecked(data.data.campaign_detail.campaign_type_google);
        setIsMicrosoftChecked(data.data.campaign_detail.campaign_type_microsoft);
        setIsOutbrainChecked(data.data.campaign_detail.campaign_type_outbrain);
        setIsTaboolaChecked(data.data.campaign_detail.campaign_type_taboola);
        setIsTiktokChecked(data.data.campaign_detail.campaign_type_tiktok);
        setIsApplovinChecked(data.data.campaign_detail.campaign_type_applovin);
        setIsChatgptChecked(data.data.campaign_detail.campaign_type_chatgpt);
        setIsLinkedinChecked(data.data.campaign_detail.campaign_type_linkedin);
        setGlConvCustomerId(data.data.campaign_detail.gl_conv_customer_id);
        setGlConvSubCustomerId(data.data.campaign_detail.gl_conv_subcustomer_id);
        setTbAdAccountId(data.data.campaign_detail.tb_ad_account_id);
        setConvAttributionModel(data.data.campaign_detail.conv_attribution_model);
        setfbUserId(data.data.facebook_data.fb_user_id);
        setfbUserAccesstoken(data.data.facebook_data.fb_user_accesstoken);
        setfbAccountsDetails(data.data.facebook_data.fb_ad_accounts_details);
        setSelectedFbAccounts(data.data.campaign_detail.fb_ad_account_id);
        setglUserRefreshtoken(data.data.google_data.gl_user_refreshtoken);
        setglAccountsDetails(data.data.google_data.gl_ad_accounts_details);
        setSelectedGlAccounts(data.data.campaign_detail.gl_ad_account_id);
        setSelectedObAccounts(data.data.campaign_detail.ob_ad_account_id);
        setSelectedMsAccounts(data.data.campaign_detail.ms_ad_account_id);
        setSelectedMsConvAdsAccounts(data.data.campaign_detail.ms_conv_ads_account_id);
        setSelectedObConvAccounts(data.data.campaign_detail.ob_conv_ad_account_id);
        setobUsertoken(data.data.outbrain_data.ob_user_token);
        setobAccountsDetails(data.data.outbrain_data.ob_ad_accounts_details);
        setfbAllConversionSend(data.data.campaign_detail.fb_all_conversion_send);
        settbUserRefreshtoken(data.data.taboola_data.tb_user_refreshtoken);
        settbAccountsDetails(data.data.taboola_data.tb_ad_accounts_details);
        setmsUserRefreshtoken(data.data.microsoft_data.ms_user_refreshtoken);
        setmsAuthorizationData(data.data.microsoft_data.ms_authorization_data);
        settkUserAccesstoken(data.data.tiktok_data.tk_user_accesstoken);
        settkAccountsDetails(data.data.tiktok_data.tk_ad_accounts_details);
        setSelectedTkAccounts(data.data.campaign_detail.tk_ad_account_id);
        setSelectedLnAccounts(data.data.campaign_detail.ln_ad_account_id);
        setSelectedTkConvAdsAccounts(data.data.campaign_detail.tk_conv_ads_account_id);
        setConversionApiType(data.data.campaign_detail.conversion_api_type);
        setLnAccesstoken(data.data.linkedin_data.ln_access_token);
      }else if(data.status === 0){
        navigate("/multiple-user-login", { state: { ip_address: data.data.ip_address, type: 'campaign', id: campaign_id } });
      }
      setCampaignLoader(false);
    })
    .catch(error => {
      console.log(error);
      setCampaignLoader(false);
    });
  };

  const handleFacebookCallback = (response) => {
    const accessToken = response.accessToken;
    const userId = response.userID;
    fetchAdAccounts(accessToken,userId);
  };

  const fetchAdAccounts = async (accessToken,userId,nextPageUrl = '') => {
    try {
      if(nextPageUrl) {
        setFbPaginationLoading(true);
      }
      const fetchUrl = nextPageUrl
        ? nextPageUrl
        : `${facebookApiPath}/me/adaccounts?fields=id,account_id,name,currency,amount_spent&limit=100&access_token=${accessToken}`;
      const response = await fetch(fetchUrl);
      const data = await response.json();

      // Store access token for pagination calls
      if(!nextPageUrl) {
        setFbAccessToken(accessToken);
      }

      // Check if there are more pages
      const nextUrl = data.paging?.next || null;
      setFbNextPageUrl(nextUrl);

      const newAccounts = data.data.map((item) => ({ ...item }));

      if(nextPageUrl) {
        // Pagination: format new accounts as a separate page
        const formattedNewAccounts = newAccounts.map((newAcc) => ({
          ad_account_id: newAcc.account_id,
          account_name: newAcc.name,
          currency: newAcc.currency,
          select_ad_account: newAcc.account_id,
          selected: ''
        }));
        // Add as new page for display (Previous/Next navigation)
        setFbAdAccountPages(prev => [...prev, formattedNewAccounts]);
        setFbCurrentPageIndex(prev => prev + 1);
        // Also append to facebookElements for DB save
        setFacebookElements(prev => [...prev, ...formattedNewAccounts]);
      }

      // Build combined data for DB save (all pages accumulated)
      const existingData = nextPageUrl ? facebookElements.map((el) => ({
        id: 'act_' + el.ad_account_id,
        account_id: el.ad_account_id,
        name: el.account_name,
        currency: el.currency
      })) : [];
      const allData = [...existingData, ...newAccounts];

      const formattedAdAccounts = {
        data: allData.map((item) => ({ ...item })),
        paging: {
          cursors: { ...data.paging.cursors },
          next: nextUrl
        }
      };

      CampaignApi.fbadsintegration({
        campaign_id:campaign_id || campaignId,
        fb_user_id:userId,
        access_token:accessToken,
        fb_ad_accounts_details:formattedAdAccounts
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          if(!nextPageUrl) {
            setfbloginResponse(data.data.fb_login_response);
            setfbResponse("fbsuccessfully");
          }
        }
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        setFbPaginationLoading(false);
      });
    } catch (error) {
      console.error('Error fetching ad accounts:', error);
      setFbPaginationLoading(false);
    }
  };

  useEffect(() => {
    if(fbloginResponse === 'connected'){
      setCampaignLoader(true);
      CampaignApi.getcampaigntypeaduserdata({
        campaign_type: 'facebook',
        campaign_id: campaignId || campaign_id
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
            setCampaignLoader(false);
          }
        }
      })
      .then(data => {
        if(data){
          if(data.data){
            if(data.data.show_fb_ad_account_login_logout_button){
              if(data.data.show_fb_ad_account_login_logout_button === 'login'){
                setFacebookLoginButton(true);
                setFacebookLogoutButton(false);
              }else if(data.data.show_fb_ad_account_login_logout_button === 'logout'){
                setFacebookLogoutButton(true);
                setFacebookLoginButton(false);
                if(data.data.fb_ad_accounts){
                  const fbad_accounts = Array.isArray(data.data.fb_ad_accounts)? data.data.fb_ad_accounts: data.data.fb_ad_accounts === "No Data Found."
                    ? [] : [data.data.fb_ad_accounts];
                  setFacebookElements(fbad_accounts);
                  const pages: any[][] = [];
                  for (let i = 0; i < fbad_accounts.length; i += 100) {
                    pages.push(fbad_accounts.slice(i, i + 100));
                  }
                  setFbAdAccountPages(pages.length > 0 ? pages : [[]]);
                  setFbCurrentPageIndex(0);
                }
                if(data.data.fb_paging_next) setFbNextPageUrl(data.data.fb_paging_next);
              }
            }
            if(data.data.facebook_app_id){
              setFacebookAppId(data.data.facebook_app_id);
            }
            if(data.data.facebook_api_path){
              setFacebookApiPath(data.data.facebook_api_path);
            }
          }
        }
        setCampaignLoader(false);
      })
      .catch(error => {
        setCampaignLoader(false);
        console.error("API Error:", error);
      });
    }
  },[fbloginResponse,fbResponse]);

  const googleLogin = useGoogleLogin({
    onSuccess: codeResponse => {
      setGoogleLoader(true);
      CampaignApi.savegoogleadaccountcredentials({
        code : codeResponse.code
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            setGoogleLoader(false);
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setGoogleLoginButton(false);
          setGoogleLogoutButton(true);
          handleGoogleChecked();
        }
      })
      .catch(error => {
        console.log(error);
        setGoogleLoader(false);
      });
    },
    onError: codeError => console.log(codeError),
    flow: 'auth-code',
    scope: 'https://www.googleapis.com/auth/adwords https://www.googleapis.com/auth/datamanager',
  });

  const removeSocialMediaIntegration = (integrationType) => modals.openConfirmModal({
    title: 'Please confirm your action',
    children: (
      <>
      <Text size="sm">
        Are you sure you want to remove this integration? Any feature relying on it will stop working immediately.
      </Text>
      <br/>
      <Text size="sm">
        If you don't want to remove the integration, you can just close this message. Otherwise click below to remove the integration now.
      </Text>
      </>
    ),
    labels: { confirm: 'Confirm', cancel: 'Cancel' },
    onCancel: () => {},
    onConfirm: () => {
      setCampaignLoader(true);
      CampaignApi.deleteadsintegrations({
        c_id : campaignId || campaign_id,
        ads_type : integrationType
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            setCampaignLoader(false);
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          if(integrationType === 'google'){
            setGoogleLoginButton(true);
            setGoogleLogoutButton(false);
          }else if(integrationType === 'outbrain'){
            setOutbrainLoginButton(true);
            setOutbrainLogoutButton(false);
          }else if(integrationType === 'taboola'){
            setTaboolaLoginButton(true);
            setTaboolaLogoutButton(false);
          }else if(integrationType === 'facebook'){
            setFacebookLoginButton(true);
            setFacebookLogoutButton(false);
          }else if(integrationType === 'microsoft'){
            setMicrosoftLoginButton(true);
            setMicrosoftLogoutButton(false);
          }else if(integrationType === 'applovin'){
            setApplovinLoginButton(true);
            setApplovinLogoutButton(false);
          }else if(integrationType === 'chatgpt'){
            setChatgptLoginButton(true);
            setChatgptLogoutButton(false);
          }else if(integrationType === 'tiktok'){
            setTiktokLoginButton(true);
            setTiktokLogoutButton(false);
            localStorage.removeItem('tiktok_auth_code');
          }else if(integrationType === 'linkedin'){
            setLinkedinLoginButton(true);
            setLinkedinLogoutButton(false);
          }
        }
        setCampaignLoader(false);
      })
      .catch(error => {
        console.log(error);
        setCampaignLoader(false);
      });
    } 
  });

  const loginTiktok = () => {
    const tiktok_redirect_uri = process.env.REACT_APP_FRONTEND_PUBLIC_URL;
    const oauthUrl = `https://ads.tiktok.com/marketing_api/auth?app_id=${tiktokAppId}&state=your_custom_params&redirect_uri=${tiktok_redirect_uri}`;
    const popup = window.open(oauthUrl, '_blank', 'width=400,height=600,scrollbars=yes,resizable=yes');
    const pollTimer = setInterval(() => {
    if (!popup || popup.closed) {
      clearInterval(pollTimer);
      return;
    }

    try {
      if (popup.location.origin === window.location.origin) {
        const params = new URLSearchParams(popup.location.search);
        const authCode = params.get("auth_code");

        if (authCode) {
          clearInterval(pollTimer);
          popup.close();
          localStorage.setItem("tiktok_auth_code", authCode);
          setCampaignLoader(true);
          CampaignApi.generatetiktokaccesstoken({ 
            auth_code: authCode 
          })
          .then(response => {
            if (response.ok) {
              return response.json();
            } else {
              if (response.status === 401 || response.status === 400) {
                navigate("/logout");
              }
            }
          })
          .then(data => {
            setTiktokLoginButton(false);
            setTiktokLogoutButton(true);
            setCampaignLoader(false);
            handleTiktokChecked();
          })
          .catch(error => {
            setCampaignLoader(false);
          });
        }
      }
    } catch (err) {
      console.error('Error:', err);
    }
  }, 100);
  };

  const loginMicrosoft = () => {
    let microsoftWin = window.open(process.env.REACT_APP_BACKEND_API_PATH+'microsoftloginpopup.php?token='+visi_token, 'formpopup', 'width=450,height=600,resizeable,scrollbars');
    const popupTick = setInterval(() => {
        if (microsoftWin.closed) {
          clearInterval(popupTick);
          handleMicrosoftChecked();
        }
      }, 2);
  };

  const loginOutBrain = () => {
    let outbrainWin = window.open(process.env.REACT_APP_BACKEND_API_PATH+'outbrainloginpopup.php?token='+visi_token, 'formpopup', 'width=450,height=600,resizeable,scrollbars');
    let popupTick = setInterval(function () {
      if (outbrainWin.closed) {
        clearInterval(popupTick);
        getOutbrainAdUserData();
      }
    }, 2);
  };

  const loginAppLovin = () => {
    let applovinWin = window.open(process.env.REACT_APP_BACKEND_API_PATH+'applovinloginpopup.php?token='+visi_token, 'formpopup', 'width=450,height=600,resizeable,scrollbars');
    let popupTick = setInterval(function () {
      if (applovinWin.closed) {
        clearInterval(popupTick);
        getApplovinAdUserData();
      }
    }, 2);
  };

  const loginChatgpt = () => {
    setChatgptToken('');
    setChatgptError('');
    setChatgptModalOpen(true);
  };

  const saveChatgptIntegration = () => {
    if(chatgptToken.trim() === ''){
      setChatgptError('Please enter your ChatGPT Ads API token.');
      return;
    }
    setChatgptSaving(true);
    setChatgptError('');
    CampaignApi.savechatgptintegration({
      chatgpt_token: chatgptToken.trim()
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      setChatgptSaving(false);
      if(data && data.status === 1){
        setChatgptModalOpen(false);
        setChatgptToken('');
        getChatgptAdUserData();
      } else {
        setChatgptError((data && data.message) ? data.message : 'Could not verify the token. Please try again.');
      }
    })
    .catch(error => {
      setChatgptSaving(false);
      setChatgptError('Could not verify the token. Please try again.');
      console.error("API Error:", error);
    });
  };

  const loginTaboola = () => {
    let outbrainWin = window.open(process.env.REACT_APP_BACKEND_API_PATH+'taboolaloginpopup.php?taboola_client_id='+taboolaClientId+'&taboola_redirect_uri='+process.env.REACT_APP_BACKEND_API_PATH+'taboolaloginpopup.php', 'formpopup', 'width=450,height=600,resizeable,scrollbars');
    let popupTick = setInterval(function () {
      if (outbrainWin.closed) {
        clearInterval(popupTick);
        // getOutbrainAdUserData();
      }
    }, 2);
  };

  const loginLinkedin = () => {
    let linkedinWin = window.open(process.env.REACT_APP_BACKEND_API_PATH+'linkedinloginpopup.php?token='+visi_token, 'formpopup', 'width=450,height=600,resizeable,scrollbars');
    let popupTick = setInterval(function () {
      if (linkedinWin.closed) {
        clearInterval(popupTick);
        getLinkedInAdUserData();
      }
    }, 2);
  };

  const getOutbrainAdUserData = () => {
    setCampaignLoader(true);
    CampaignApi.getcampaigntypeaduserdata({
      campaign_type: 'outbrain',
      campaign_id: campaignId || campaign_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data){
        if(data.data){
          if(data.data.show_ob_ad_account_login_logout_button){
            if(data.data.show_ob_ad_account_login_logout_button === 'login'){
              setOutbrainLoginButton(true);
              setOutbrainLogoutButton(false);
            }else if(data.data.show_ob_ad_account_login_logout_button === 'logout'){
              setOutbrainLogoutButton(true);
              setOutbrainLoginButton(false);
              if(data.data.ob_ad_accounts){
                const obad_accounts = Array.isArray(data.data.ob_ad_accounts)? data.data.ob_ad_accounts: data.data.ob_ad_accounts === "No Data Found."
                    ? [] : [data.data.ob_ad_accounts];
                setOutbrainElements(obad_accounts);
              }
            }
          }          
          setCampaignLoader(false);
        }
      }
    })
    .catch(error => {
      setCampaignLoader(false);
      console.error("API Error:", error);
    });
  }

  const getApplovinAdUserData = () => {
    setCampaignLoader(true);
    CampaignApi.getcampaigntypeaduserdata({
      campaign_type: 'applovin',
      campaign_id: campaignId || campaign_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data){
        if(data.data){
          if(data.data.show_al_ad_account_login_logout_button){
            if(data.data.show_al_ad_account_login_logout_button === 'login'){
              setApplovinLoginButton(true);
              setApplovinLogoutButton(false);
            }else if(data.data.show_al_ad_account_login_logout_button === 'logout'){
              setApplovinLogoutButton(true);
              setApplovinLoginButton(false);
            }
          }
          setCampaignLoader(false);
        }
      }
    })
    .catch(error => {
      setCampaignLoader(false);
      console.error("API Error:", error);
    });
  }

  const getChatgptAdUserData = () => {
    setCampaignLoader(true);
    CampaignApi.getcampaigntypeaduserdata({
      campaign_type: 'chatgpt',
      campaign_id: campaignId || campaign_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data){
        if(data.data){
          if(data.data.show_cgpt_ad_account_login_logout_button){
            if(data.data.show_cgpt_ad_account_login_logout_button === 'login'){
              setChatgptLoginButton(true);
              setChatgptLogoutButton(false);
            }else if(data.data.show_cgpt_ad_account_login_logout_button === 'logout'){
              setChatgptLogoutButton(true);
              setChatgptLoginButton(false);
            }
          }
          setCampaignLoader(false);
        }
      }
    })
    .catch(error => {
      setCampaignLoader(false);
      console.error("API Error:", error);
    });
  }

  const getTaboolaAdUserData = () => {
    setCampaignLoader(true);
    CampaignApi.getcampaigntypeaduserdata({
      campaign_type: 'taboola',
      campaign_id: campaignId || campaign_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data){
        if(data.data){
          if(data.data.show_tb_ad_account_login_logout_button){
            if(data.data.show_tb_ad_account_login_logout_button === 'login'){
              setTaboolaLoginButton(true);
              setTaboolaLogoutButton(false);
            }else if(data.data.show_tb_ad_account_login_logout_button === 'logout'){
              setTaboolaLogoutButton(true);
              setTaboolaLoginButton(false);
              if(data.data.tb_ad_accounts){
                const tbad_accounts = Array.isArray(data.data.tb_ad_accounts)? data.data.tb_ad_accounts: data.data.tb_ad_accounts === "No Data Found."
                    ? [] : [data.data.tb_ad_accounts];
                setTaboolaElements(tbad_accounts);
              }
            }
          }
          if(data.data.taboola_client_id){
            setTaboolaClientId(data.data.taboola_client_id);
          }          
          setCampaignLoader(false);
        }
      }
    })
    .catch(error => {
      setCampaignLoader(false);
      console.error("API Error:", error);
    });
  }

  const getLinkedInAdUserData = () => {
    setCampaignLoader(true);
    CampaignApi.getcampaigntypeaduserdata({
      campaign_type: 'linkedin',
      campaign_id: campaignId || campaign_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data){
        if(data.data){
          if(data.data.show_ln_ad_account_login_logout_button){
            if(data.data.show_ln_ad_account_login_logout_button === 'login'){
              setLinkedinLoginButton(true);
              setLinkedinLogoutButton(false);
            }else if(data.data.show_ln_ad_account_login_logout_button === 'logout'){
              setLinkedinLogoutButton(true);
              setLinkedinLoginButton(false);
              if(data.data.ln_ad_accounts){
                const lnad_accounts = Array.isArray(data.data.ln_ad_accounts)? data.data.ln_ad_accounts: data.data.ln_ad_accounts === "No Data Found."
                    ? [] : [data.data.ln_ad_accounts];
                setLinkedinElements(lnad_accounts);
              }
            }
          }          
          if(data.data.ln_access_token){
            setLnAccesstoken(data.data.ln_access_token);
          }
          setCampaignLoader(false);
        }
      }
    })
    .catch(error => {
      setCampaignLoader(false);
      console.error("API Error:", error);
    });
  }

  const submitStep3 = () => {
    let hasEmptyCustomer = false;
    let errorMessage = "";
    if(isFacebookChecked && facebookLoginButton){
      hasEmptyCustomer = true;
      errorMessage += 'Please Login with Facebook.\n'
    }
    if(isGoogleChecked && googleLoginButton){
      hasEmptyCustomer = true;
      errorMessage += 'Please Login with Google.\n'
    }
    if(isMicrosoftChecked && microsoftLoginButton){
      hasEmptyCustomer = true;
      errorMessage += 'Please Login with Microsoft.\n'
    }
    if(isTiktokChecked && tiktokLoginButton){
      hasEmptyCustomer = true;
      errorMessage += 'Please Login with Tiktok.\n'
    }
    if(isTaboolaChecked && taboolaLoginButton){
      hasEmptyCustomer = true;
      errorMessage += 'Please Login with Taboola.\n'
    }
    if(isOutbrainChecked && outbrainLoginButton){
      hasEmptyCustomer = true;
      errorMessage += 'Please Login with Outbrain.\n'
    }
    if(isApplovinChecked && applovinLoginButton){
      hasEmptyCustomer = true;
      errorMessage += 'Please Login with Applovin.\n'
    }
    if(isChatgptChecked && chatgptLoginButton){
      hasEmptyCustomer = true;
      errorMessage += 'Please connect your ChatGPT Ads account.\n'
    }
    if(isFacebookChecked && facebookLogoutButton && selectedFbAccounts.length === 0){
      hasEmptyCustomer = true;
      errorMessage += 'Please select at least one active account for your Facebook integration and save it.\n'
    }
    if(isGoogleChecked && googleLogoutButton && selectedGlAccounts === ''){
      hasEmptyCustomer = true;
      errorMessage += 'Please select at least one active account for your Google integration and save it.\n'
    }
    if(isMicrosoftChecked && microsoftLogoutButton && selectedMsAccounts === ''){
      hasEmptyCustomer = true;
      errorMessage += 'Please select at least one active account for your Microsoft integration and save it.\n'
    }
    if(isTiktokChecked && tiktokLogoutButton && selectedTkAccounts === ''){
      hasEmptyCustomer = true;
      errorMessage += 'Please select at least one active account for your Tiktok integration and save it.\n'
    }
    if(isTaboolaChecked && taboolaLogoutButton && selectedTbAccounts === ''){
      hasEmptyCustomer = true;
      errorMessage += 'Please select at least one active account for your Taboola integration and save it.\n'
    }
    if(isOutbrainChecked && outbrainLogoutButton && selectedObAccounts === ''){
      hasEmptyCustomer = true;
      errorMessage += 'Please select at least one active account for your Outbrain integration and save it.\n'
    }
    if(isLinkedinChecked && linkedinLogoutButton && selectedLnAccounts === ''){
      hasEmptyCustomer = true;
      errorMessage += 'Please select at least one active account for your LinkedIn integration and save it.\n'
    }
    if (hasEmptyCustomer) {
      modals.open({
        trapFocus: false,
        title: 'Please correct the following errors:',
        children: (
        <>
          <Text size="sm" style={{ whiteSpace: "pre-line" }}>
            {errorMessage.trim()}
          </Text>
          <Group position="right" mt="sm">
            <Button onClick={() => modals.closeAll()}>OK</Button>
          </Group>
        </>
        ),
      });
      return;
    }
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setStepValue('step-4');
  };


  const campaignnMsgArray = [
    "Spinning up your campaign—kind of like starting a rocket launch, but with less fire.",
    "Your campaign is getting its toolkit ready: tracking, testing, and a splash of magic.",
    "Setting the stage… your campaign is almost ready to steal the spotlight."
  ];
  const [displayMsg, setDisplayMsg] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;

    if (googleLoader) {
      const randomNum = Math.floor(Math.random() * campaignnMsgArray.length);
      setDisplayMsg(campaignnMsgArray[randomNum]);
      setShowMessage(true);
      interval = setInterval(() => {
        const randomIndex = Math.floor(Math.random() * campaignnMsgArray.length);
        setDisplayMsg(campaignnMsgArray[randomIndex]);
      }, 5000);
    } else {
      setShowMessage(false);
    }

    return () => {
      clearInterval(interval);
    };
  }, [googleLoader]);

	return (
	  <>
	  <VisiLoader VisiLoaderVisible={campaignLoader} loaderType="campaign" />
    <LoadingOverlay
      visible={googleLoader}
      overlayBlur={2}
      loader={
        <Stack align="center" spacing="xs">
          <Loader variant="bars" color="gray" />
          {showMessage && (
            <Text size="md" weight={700} c="#4d73e2" style={{ fontStyle: 'italic', fontSize: '1.2rem', animation: 'fadeIn 0.5s ease-in-out' }}>
              {displayMsg}
            </Text>
          )}
        </Stack>
      }
      style={{ width: '100%', height: '100%', display: 'flex', position: 'fixed', zIndex: 9999999999 }}
    />
	  <HeaderMenu HeaderMenuValue={selectedMemberWebsite} HeaderMenuOnChange={handleHeaderMenuComponentChange}/>
	  <Modal opened={isMessageModelOpen} onClose={handleCloseModal} withCloseButton={false} size="60%" closeOnEscape={false} closeOnClickOutside={false} trapFocus={false}>
      {(() => {
        const lines = isModelMessage.split('\n');
        const isParamLine = (l: string) => {
          const t = l.trim();
          return t.startsWith('{lpurl}') || t.startsWith('visi_source=') || t.startsWith('visi_ai=');
        };
        return lines.map((line, index) => {
          const trimmed = line.trim();
          if (isParamLine(line)) {
            return (
              <Group
                key={index}
                spacing="xs"
                noWrap
                align="center"
                mt={6}
                mb={6}
                style={{
                  background: '#f1f3f5',
                  border: '1px solid #dee2e6',
                  borderRadius: 4,
                  padding: '8px 10px',
                }}
              >
                <Code
                  style={{
                    flex: 1,
                    background: 'transparent',
                    padding: 0,
                    wordBreak: 'break-all',
                    fontSize: '0.9rem',
                    color: '#1864ab',
                  }}
                >
                  {trimmed}
                </Code>
                <CopyButton value={trimmed} timeout={2000}>
                  {({ copied, copy }) => (
                    <Tooltip label={copied ? 'Copied' : 'Copy to clipboard'} withArrow position="left">
                      <ActionIcon variant="subtle" color={copied ? 'teal' : 'blue'} onClick={copy} aria-label="Copy parameters">
                        {copied ? <IconCheck size="1rem" /> : <IconCopy size="1rem" />}
                      </ActionIcon>
                    </Tooltip>
                  )}
                </CopyButton>
              </Group>
            );
          }
          // Drop empty lines that border a parameter block — the Group's own margin already provides spacing.
          if (trimmed === '') {
            const prevIsParam = index > 0 && isParamLine(lines[index - 1]);
            const nextIsParam = index < lines.length - 1 && isParamLine(lines[index + 1]);
            if (prevIsParam || nextIsParam) {
              return null;
            }
          }
          const segments = line.split(/(\*\*[^*]+\*\*)/g);
          return (
            <React.Fragment key={index}>
              {segments.map((segment, segIndex) => {
                if (segment.startsWith('**') && segment.endsWith('**')) {
                  return <strong key={segIndex}>{segment.slice(2, -2)}</strong>;
                }
                return <React.Fragment key={segIndex}>{segment}</React.Fragment>;
              })}
              <br />
            </React.Fragment>
          );
        });
      })()}
      <div style={{float: 'right', margin: '10px'}}>
        <Button onClick={() => setIsMessageModelOpen(false)}>OK</Button>
      </div>
    </Modal>

    {/*ChatGPT Ads token connect modal*/}
    <Modal opened={chatgptModalOpen} onClose={() => setChatgptModalOpen(false)} title="Connect ChatGPT Ads" trapFocus={false} closeOnClickOutside={!chatgptSaving}>
      <Text size="sm" mb={10}>Generate an API key in the Settings tab of your Ads Manager account (ads.openai.com) and paste it below.</Text>
      <TextInput
        label="API Token"
        placeholder="Enter API Token"
        value={chatgptToken}
        onChange={(event) => setChatgptToken(event.currentTarget.value)}
        error={chatgptError}
        disabled={chatgptSaving}
        data-autofocus
      />
      <Group position="right" mt="md">
        <Button variant="default" onClick={() => setChatgptModalOpen(false)} disabled={chatgptSaving}>Cancel</Button>
        <Button onClick={() => saveChatgptIntegration()} loading={chatgptSaving} style={{backgroundColor:"#10A37F"}}>Connect</Button>
      </Group>
    </Modal>

  	<Container size="xl">
  		<Card shadow="sm" padding="sm" radius="md" withBorder>
	  	  <Group position="apart" mb="xs">
	  	    <Text weight={500}>Campaign <HelpTip helpId={159} /></Text>
	  	  </Group>
	  	  <Container size="xl" px={0}>
	  	    <Accordion chevronPosition="right" defaultValue="step-1" variant="separated" value={stepValue} onChange={setStepValue}>
	  	      <Step1
              selectedMemberWebsite={selectedMemberWebsite}
              campaign_id={campaign_id}
              campaignId={campaignId}
              setCampaignId={setCampaignId}
              SelectedFunnelValue={SelectedFunnelValue}
              setSelectedFunnelValue={setSelectedFunnelValue}
              campaignLPPageValue={campaignLPPageValue}
              setCampaignLPPage={setCampaignLPPage}
              campaignName={campaignName}
              setCampaignName={setCampaignName}
              step1Disabled={false}
              step1FieldDisabled={step1FieldDisabled}
              setStep3Disabled={setStep3Disabled}
              setStep4Disabled={setStep4Disabled}
              setStepValue={setStepValue}
              campaignLoader={setCampaignLoader}
            />
            {/*for Step 2 remove and this is step 3 - Campaign Type*/}
	  	      <Accordion.Item className={classes.item} value="step-3">
	  	        <Accordion.Control disabled={step3Disabled}><Text component="span" color="red" weight={500}>Step 2</Text><Text component="span" weight={500}> - Campaign Type </Text><HelpTip helpId={232} /></Accordion.Control>
 	  	        <Accordion.Panel>
 	  	        	<div style={{ marginBottom:5}}><span style={{ marginLeft:2 }}><strong style={{ color: 'red'}}>2A - </strong><strong>Ad Platform :</strong></span></div>
 	  	          <Checkbox mb={5}
 	  	          	name="campaign_type_classic"
 	  	          	checked={isClassicChecked}
 	  	          	onChange={(event) => handleSocialMediaCheckboxChange(event,'Classic')}
 	  	            label={<span><strong>Classic (Manual) - </strong> You choose goals. (pages, webhooks, postbacks, or buttons) </span>}
 	  	          />
 	  	          {/*Facebook*/}
 	  	          <Checkbox mb={5}
 	  	          	name="campaign_type_facebook"
 	  	          	checked={isFacebookChecked}
 	  	          	onChange={(event) => handleSocialMediaCheckboxChange(event,'Facebook')}
 	  	            label={<span><strong>Meta (Facebook & Instagram) - </strong> Connect and pull data from your Meta campaigns.</span>}
 	  	          />
 	  	          {isFacebookChecked ? (
 	  	          <>
                {facebookLoginButton &&
   	  	          <Group mb={3} ml={35}>
                  <FacebookLogin
                    appId={facebookAppId}
                    autoLoad={false}
                    fields="name,email,picture"
                    onSuccess={handleFacebookCallback}
                    scope="business_management,ads_read"
                    render={renderProps => (
                      <Button onClick={renderProps.onClick} leftIcon={<IconBrandFacebook stroke={2} />} style={{backgroundColor:"#0c6ec2"}}>
                    Login with Facebook
                    </Button>
                    )}
                  />
  	 	  	        </Group>
                }
                {facebookLogoutButton && (<>
   	  	          <Button color="red" mb={5} ml={35} onClick={() => removeSocialMediaIntegration('facebook')}>
  	                Remove Facebook Integration
  	              </Button>
  	              <Group spacing="xs" ml={35} mb={15}>
  	 	  	          <div style={{ marginBottom:5}}><span style={{ marginLeft:2 }}><strong style={{ color: 'red'}}>2B - </strong><strong>Select Ad Account :</strong></span></div>
  	 	  	          <Table striped highlightOnHover withBorder>
  		                <thead>
  		                	<tr>
  	              	      <th>Ad Account ID</th>
  	              	      <th>Account Name</th>
  	              	      <th>Currency</th>
  	              	      <th>Select Ad Account</th>
  	              	    </tr>
  		                </thead>
  		                <tbody>{facebookRows}</tbody>
  		              </Table>
                    {(hasPrevFbPage || hasNextFbPage) && (
                      <Group mt={10} position="apart">
                        <Button
                          onClick={handleFbPrevPage}
                          variant="outline"
                          disabled={!hasPrevFbPage}
                        >
                          Previous
                        </Button>
                        <Text size="sm">Page {fbCurrentPageIndex + 1}</Text>
                        <Button
                          onClick={handleFbNextPage}
                          loading={fbPaginationLoading}
                          variant="outline"
                          disabled={!hasNextFbPage}
                        >
                          Next
                        </Button>
                      </Group>
                    )}
  		            </Group>
                </>)}
		            </>)
		            : <></>}

	              {/*Google*/}
 	  	          <Checkbox mb={5}
 	  	          	name="campaign_type_google"
 	  	          	checked={isGoogleChecked}
 	  	          	onChange={(event) => handleSocialMediaCheckboxChange(event,'Google')}
 	  	            label={<span><strong>Google Ads - </strong> Connect and pull data from your Google campaign.</span>}
 	  	          />
 	  	          {isGoogleChecked ? (
 	  	          <>
                {googleLoginButton &&
   	  	          <Group mb={5} ml={35}>
                   <Button onClick={() => googleLogin()} leftIcon={<IconBrandGoogle stroke={2} />}>
                    Sign in with Google
                   </Button>
  	 	  	        </Group>
                }
                {googleLogoutButton && (<>
   	  	          <Button color="red" mb={5} ml={35} onClick={() => removeSocialMediaIntegration('google')}>
  	                Remove Google Integration
  	              </Button>
  	              <Group spacing="xs" ml={35} mb={15}>
  	 	  	          <div style={{ marginBottom:5}}><span style={{ marginLeft:2 }}><strong style={{ color: 'red'}}>2B - </strong><strong>Select Ad Account :</strong></span></div>
  	 	  	          <Table striped highlightOnHover withBorder>
  		                <thead>
  		                	<tr>
  		                		<th>Customer ID</th>
  	              	      <th>Subcustomer ID</th>
  	              	      <th>Subcustomer Name</th>
  	              	      <th>Currency</th>
  	              	      <th>Select Subcustomer Ad Account</th>
  	              	    </tr>
  		                </thead>
  		                <tbody>{googleRows}</tbody>
  		              </Table>
  		            </Group>
                </>)}
		            </>)
		            : <></>}

	              {/*Microsoft*/}
 	  	          <Checkbox mb={5}
 	  	          	name="campaign_type_microsoft"
 	  	          	checked={isMicrosoftChecked}
 	  	          	onChange={(event) => handleSocialMediaCheckboxChange(event,'Microsoft')}
 	  	            label={<span><strong>Microsoft (Bing) - </strong> Connect and pull data from your Microsoft campaign.</span>}
 	  	          />
 	  	          {isMicrosoftChecked ? (
 	  	          <>
                {microsoftLoginButton &&
                  <Group mb={5} ml={35}>
                    <Button onClick={() => loginMicrosoft()} leftIcon={<IconBrandWindows stroke={2} />}>
                      Sign in with Microsoft
                     </Button>
                  </Group>
                }
                {microsoftLogoutButton && (<>
   	  	          <Button color="red" mb={5} ml={35} onClick={() => removeSocialMediaIntegration('microsoft')}>
  	                Remove Microsoft Integration
  	              </Button>
  	              <Group spacing="xs" ml={35} mb={15}>
  	 	  	          <div style={{ marginBottom:5}}><span style={{ marginLeft:2 }}><strong style={{ color: 'red'}}>2B - </strong><strong>Select Ad Account :</strong></span></div>
  	 	  	          <Table striped highlightOnHover withBorder>
  		                <thead>
  		                	<tr>
  	              	      <th>Ad Account ID</th>
  	              	      <th>Account Name</th>
  	              	      <th>Currency</th>
  	              	      <th>Select Ad Account</th>
  	              	    </tr>
  		                </thead>
  		                <tbody>{microsoftRows}</tbody>
  		              </Table>
  		            </Group>
                </>)}
		            </>)
		            : <></>}

	              {/*Tiktok*/}
 	  	          <Checkbox mb={5}
 	  	          	name="campaign_type_tiktok"
 	  	          	checked={isTiktokChecked}
 	  	          	onChange={(event) => handleSocialMediaCheckboxChange(event,'Tiktok')}
 	  	            label={<span><strong>Tiktok - </strong> Connect and pull data from your Tiktok campaign.</span>}
 	  	          />
 	  	          {isTiktokChecked ? (
 	  	          <>
                {tiktokLoginButton &&
   	  	          <Group mb={5} ml={35}>
  	 	  	          <Button onClick={() => loginTiktok()} leftIcon={<IconBrandTiktok stroke={2} />} style={{backgroundColor:"black"}}>
  	 	  	          Login with Tiktok
  	 	  	          </Button>
  	 	  	        </Group>
                }
                {tiktokLogoutButton && (<>
   	  	          <Button color="red" mb={5} ml={35} onClick={() => removeSocialMediaIntegration('tiktok')}>
  	                Remove Tiktok Integration
  	              </Button>
  	              <Group spacing="xs" ml={35} mb={15}>
  	 	  	          <div style={{ marginBottom:5}}><span style={{ marginLeft:2 }}><strong style={{ color: 'red'}}>2B - </strong><strong>Select Ad Account :</strong></span></div>
  	 	  	          <Table striped highlightOnHover withBorder>
  		                <thead>
  		                	<tr>
  	              	      <th>Ad Account ID</th>
  	              	      <th>Account Name</th>
  	              	      <th>Currency</th>
  	              	      <th>Select Ad Account</th>
  	              	    </tr>
  		                </thead>
  		                <tbody>{tiktokRows}</tbody>
  		              </Table>
  		            </Group>
                </>)}
		            </>)
		            : <></>}

	              {/*Taboola*/}
 	  	          <Checkbox mb={5}
 	  	          	name="campaign_type_taboola"
 	  	          	checked={isTaboolaChecked}
 	  	          	onChange={(event) => handleSocialMediaCheckboxChange(event,'Taboola')}
 	  	            label={<span><strong>Taboola - </strong> Connect and pull data from your Taboola campaign.</span>}
 	  	          />
 	  	          {isTaboolaChecked ? (
 	  	          <>
                {taboolaLoginButton &&
   	  	          <Group mb={5} ml={35}>
  	 	  	          <Button onClick={() => loginTaboola()} variant="outline" color="blue.9">
  	 	  	            <Image src="/img/social-media/taboola-icon.png" mr={5}/>Login with Taboola
  	 	  	          </Button>
  	 	  	        </Group>
                }
                {taboolaLogoutButton && (<>
   	  	          <Button color="red" mb={5} ml={35} onClick={() => removeSocialMediaIntegration('taboola')}>
  	                Remove Taboola Integration
  	              </Button>
  	              <Group spacing="xs" ml={35} mb={15}>
  	 	  	          <div style={{ marginBottom:5}}><span style={{ marginLeft:2 }}><strong style={{ color: 'red'}}>2B - </strong><strong>Select Ad Account :</strong></span></div>
  	 	  	          <Table striped highlightOnHover withBorder>
  		                <thead>
  		                	<tr>
  	              	      <th>Ad Account ID</th>
  	              	      <th>Account Name</th>
  	              	      <th>Currency</th>
  	              	      <th>Select Ad Account</th>
  	              	    </tr>
  		                </thead>
  		                <tbody>{taboolaRows}</tbody>
  		              </Table>
  		            </Group>
                </>)}
		            </>)
		            : <></>}

	              {/*Outbrain*/}
 	  	          <Checkbox mb={5}
 	  	          	name="campaign_type_outbrain"
 	  	          	checked={isOutbrainChecked}
 	  	          	onChange={(event) => handleSocialMediaCheckboxChange(event,'Outbrain')}
 	  	            label={<span><strong>Outbrain - </strong> Connect and pull data from your Outbrain campaign.</span>}
 	  	          />
 	  	          {isOutbrainChecked ? (
 	  	          <>
                {outbrainLoginButton &&
   	  	          <Group mb={5} ml={35}>
  	 	  	          <Button onClick={() => loginOutBrain()} variant="outline" color="orange">
  	 	  	            <Image src="/img/social-media/outbrain-icon.png" mr={5}/>Connect Outbrain
  	 	  	          </Button>
  	 	  	        </Group>
                }
                {outbrainLogoutButton && (<>
   	  	          <Button color="red" mb={5} ml={35} onClick={() => removeSocialMediaIntegration('outbrain')}>
  	                Remove Outbrain Integration
  	              </Button>
  	              <Group spacing="xs" ml={35} mb={15}>
  	 	  	          <div style={{ marginBottom:5}}><span style={{ marginLeft:2 }}><strong style={{ color: 'red'}}>2B - </strong><strong>Select Ad Account :</strong></span></div>
  	 	  	          <Table striped highlightOnHover withBorder>
  		                <thead>
  		                	<tr>
  	              	      <th>Ad Account ID</th>
  	              	      <th>Account Name</th>
  	              	      <th>Currency</th>
  	              	      <th>Select Ad Account</th>
  	              	    </tr>
  		                </thead>
  		                <tbody>{outbrainRows}</tbody>
  		              </Table>
  		            </Group>
                </>)}
		            </>)
		            : <></>}

                {/*APPLOVIN INTEGRATION*/}
                <Checkbox mb={5}
                  name="campaign_type_applovin"
                  checked={isApplovinChecked}
                  onChange={(event) => handleSocialMediaCheckboxChange(event,'Applovin')}
                  label={<span><strong>Applovin - </strong> Connect and pull data from your Applovin campaign.</span>}
                />
                {isApplovinChecked ? (
                <>
                {applovinLoginButton &&
                  <Group mb={5} ml={35}>
                    <Button onClick={() => loginAppLovin()} variant="outline" color="blue">
                      <Image src="/img/social-media/applovin_icon.png" mr={5}/>Connect Applovin
                    </Button>
                  </Group>
                }
                {applovinLogoutButton && (<>
                  <Group>
                    <Button color="red" mb={5} ml={35} onClick={() => removeSocialMediaIntegration('applovin')}>
                      Remove Applovin Integration
                    </Button>
                  </Group>
                </>)}
                </>)
                : <></>}

                <Checkbox mb={5}
                  name="campaign_type_linkedin"
                  checked={isLinkedinChecked}
                  onChange={(event) => handleSocialMediaCheckboxChange(event,'Linkedin')}
                  label={<span><strong>LinkedIn - </strong> Connect and pull data from your LinkedIn campaign.</span>}
                />
                {isLinkedinChecked ? (
                  <>
                    {linkedinLoginButton &&
                      <Group mb={5} ml={35}>
                        <Button onClick={() => loginLinkedin()} leftIcon={<IconBrandLinkedin stroke={2} />} style={{backgroundColor:"black"}}>
                        Login with LinkedIn
                        </Button>
                      </Group>
                    }
                    {linkedinLogoutButton && (<>
                      <Button color="red" mb={5} ml={35} onClick={() => removeSocialMediaIntegration('linkedin')}>
                        Remove LinkedIn Integration
                      </Button>
                      <Group spacing="xs" ml={35} mb={15}>
                        <div style={{ marginBottom:5}}><span style={{ marginLeft:2 }}><strong style={{ color: 'red'}}>2B - </strong><strong>Select Ad Account :</strong></span></div>
                        <Table striped highlightOnHover withBorder>
                          <thead>
                            <tr>
                              <th>Ad Account ID</th>
                              <th>Account Name</th>
                              <th>Currency</th>
                              <th>Select Ad Account</th>
                            </tr>
                          </thead>
                          <tbody>{linkedinRows}</tbody>
                        </Table>
                      </Group>
                    </>)}
                  </>
                )
                : <></>}

                {/*CHATGPT INTEGRATION*/}
                <Checkbox mb={5}
                  name="campaign_type_chatgpt"
                  checked={isChatgptChecked}
                  onChange={(event) => handleSocialMediaCheckboxChange(event,'Chatgpt')}
                  label={<span><strong>ChatGPT - </strong> Connect and pull data from your ChatGPT paid ad campaigns.</span>}
                />
                {isChatgptChecked ? (
                <>
                {chatgptLoginButton &&
                  <Group mb={5} ml={35}>
                    <Button onClick={() => loginChatgpt()} leftIcon={<IconBrandOpenai stroke={2} />} style={{backgroundColor:"black"}}>
                      Connect ChatGPT
                    </Button>
                  </Group>
                }
                {chatgptLogoutButton && (<>
                  <Group>
                    <Button color="red" mb={5} ml={35} onClick={() => removeSocialMediaIntegration('chatgpt')}>
                      Remove ChatGPT Integration
                    </Button>
                  </Group>
                </>)}
                </>)
                : <></>}

		            <Button type="button" mt={5} onClick={() => submitStep3()}>Continue</Button>
 	  	        </Accordion.Panel>
	  	      </Accordion.Item>
            <Step4 
              selectedMemberWebsite={selectedMemberWebsite}
              SelectedFunnelValue={SelectedFunnelValue}
              // handleCampaignLPPageChange={handleCampaignLPPageChange}
              campaignLPPageValue={campaignLPPageValue}
              // selectedWebhookPageid={selectedWebhookPage}
              campaign_id={campaign_id}
              campaignId={campaignId}
              campaignName={campaignName}
              step4Disabled={step4Disabled}
              campaignLoader={setCampaignLoader}
              setStep5Disabled={setStep5Disabled}
              stepValue={stepValue}
              setStepValue={setStepValue}
              setStep5Show={setStep5Show}

              isClassicChecked={isClassicChecked}
              isFacebookChecked={isFacebookChecked}
              isGoogleChecked={isGoogleChecked}
              isMicrosoftChecked={isMicrosoftChecked}
              isTiktokChecked={isTiktokChecked}
              isTaboolaChecked={isTaboolaChecked}
              isOutbrainChecked={isOutbrainChecked}
              isApplovinChecked={isApplovinChecked}
              isChatgptChecked={isChatgptChecked}
              isLinkedinChecked={isLinkedinChecked}

              gl_check_existing={"gl_check_existing"}
              ms_check_existing={"ms_check_existing"}
              tk_check_existing={"tk_check_existing"}
              tb_check_existing={"tb_check_existing"}
              ob_check_existing={"ob_check_existing"}

              fbuseraccesstoken={fbUserAccesstoken}
              fbuserid={fbUserId}
              fbadaccountid={formattedSelectedFbAccounts}
              fbadaccountsdetails={fbAccountsDetails}
              glUserRefreshtoken={glUserRefreshtoken}
              glAccountsDetails={glAccountsDetails}
              gladaccountid={selectedGlAccounts}
              obUsertoken={obUsertoken}
              obAccountsDetails={obAccountsDetails}
              obadaccountid={selectedObAccounts}
              tbUserRefreshtoken={tbUserRefreshtoken}
              tbAccountsDetails={tbAccountsDetails}
              tbadaccountid={selectedTbAccounts}
              msUserRefreshtoken={msUserRefreshtoken}
              msAuthorizationData={msAuthorizationData}
              msadaccountid={selectedMsAccounts}
              tkUserAccesstoken={tkUserAccesstoken}
              tkAccountsDetails={tkAccountsDetails}
              tkadaccountid={selectedTkAccounts}
              lnadaccountid={selectedLnAccounts}
              convAttributionModel={convAttributionModel}
              conversionApiType={conversionApiType !== '' ? conversionApiType : 'facebook'}
            />
            <Step5
              selectedMemberWebsite={selectedMemberWebsite}
              campaign_id={campaign_id}
              campaignId={campaignId}
              glConvCustomerId={glConvCustomerId}
              glConvSubCustomerId={glConvSubCustomerId}
              tbAdAccountId={tbAdAccountId}
              step5Disabled={step5Disabled}
              campaignLoader={setCampaignLoader}
              setStep5Disabled={setStep5Disabled}
              setStepValue={setStepValue}
              setStep5Show={step5Show}
              step5Show={step5Show}
              convAttributionModel={convAttributionModel}
              handleConvAttributionModelChange={handleConvAttributionModelChange}
              sendAllConversionFb={fbAllConversionSend}
              isFacebookChecked={isFacebookChecked === true ? true : false}
              isGoogleChecked={isGoogleChecked === true ? true : false}
              isMicrosoftChecked={isMicrosoftChecked === true ? true : false}
              isTiktokChecked={isTiktokChecked === true ? true : false}
              isTaboolaChecked={isTaboolaChecked === true ? true : false}
              isOutbrainChecked={isOutbrainChecked === true ? true : false}
              isLinkedInChecked={isLinkedinChecked === true ? true : false}
              obConvadaccountid={selectedObConvAccounts}
              msConvadaccountid={selectedMsConvAdsAccounts}
              conversionApiType={conversionApiType !== '' ? conversionApiType : 'facebook'}
              tkConvAdAccountId={selectedTkConvAdsAccounts}
              tkUserAccesstoken={tkUserAccesstoken}
              glUserRefreshtoken={glUserRefreshtoken}
              tbUserRefreshtoken={tbUserRefreshtoken}
              obUsertoken={obUsertoken}
              msUserRefreshtoken={msUserRefreshtoken}
              lnadaccountid={selectedLnAccounts}
              lnAccesstoken={lnAccesstoken}
              isChatgptChecked={isChatgptChecked === true ? true : false}
            />
	  	    </Accordion>
	  	  </Container>
	  	</Card>
	  </Container>
	  </>
	);
}